<template>
    <div class="wrapper">
      <div class="body">
        <div :class="{'text': true, 'text-ellipsis-1-no-wrap': !show_more}"
          @click="showMore"
          >
          {{ notification.contexts.item_solution.text }}
        </div>
      </div>

      <div class="actions">
        <div v-if="commentBodyIsMoreThan3Lines && show_more" @click="showMore"><i class="icon-angle-top"></i> Show less</div>
        <div v-else-if="commentBodyIsMoreThan3Lines" @click="showMore"><i class="icon-angle-bottom"></i> Show more</div>
        <NuxtLink :to="notification.contexts.item_problem.link"><i class="icon-external"></i> Go to solution</NuxtLink>        
      </div>
      
    </div>    
  </template>
  
<script setup lang="ts">
   
const props = defineProps<{ notification: Notification }>()
   


const show_more = ref(false);

const commentBodyIsMoreThan3Lines = computed(() => {
  return props.notification.contexts.item_solution.text.split('\n').length > 1;
})

const showMore = () => {
  show_more.value = !show_more.value;
}


  </script>
  
  <style scoped>
  
.wrapper{
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
}
.body{
  width: 100%;
}
.actions{
  width: 100%;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
.actions > *{
  cursor: pointer;
    display: flex;
    color: var(--gd-button-light-small-color);
    font-size: 0.75rem;
    text-transform: capitalize;
    position: relative;
    align-items: center;
    gap: 5px;
}
.text{  
  white-space: pre-wrap;
}

  
  </style> 